import {CodeComponent} from "../../../../../app/components/code/CodeComponent";
import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";

export function HashMapInsertCabFullCaption() {
    return (<FullCaptionComponent title="Value: cab">
        <HashMapInsertCab1/>
        <HashMapInsertCab2/>
        <HashMapInsertCab3/>
        <HashMapInsertCab4/>
        <HashMapInsertCab5/>
    </FullCaptionComponent>)
}

export function HashMapInsertCab1() {
    return (<CaptionStepComponent title={<h6>
        1. Check if our <CodeComponent className="codeValue">VALUE</CodeComponent> is
        unique. <CodeComponent>O(1)</CodeComponent>
    </h6>}>
        <p>HashMaps only contain unique <CodeComponent className="codeValue">VALUES</CodeComponent>. We should first
            call our <CodeComponent>contains</CodeComponent> function to make sure we don't already have "cab" in
            our HashMap. In this case, we do not already have "cab", so we are good to continue.</p>
    </CaptionStepComponent>)
}

export function HashMapInsertCab2() {
    return (<CaptionStepComponent title={<h6>
        2. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent>
    </h6>}>
        <p>Let's assume that if we input our <CodeComponent className="codeKey">KEY</CodeComponent> of "abc" into
            our <CodeComponent>generateHash</CodeComponent> function, it will output a <CodeComponent
                className="codeHash">HASH</CodeComponent> of 1.</p>
    </CaptionStepComponent>)
}

export function HashMapInsertCab3() {
    return (<CaptionStepComponent title={<h6>
        3. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent>
    </h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 1, we now want to find the
            sub-collection at index 1 of our array. Again, we see there is no collision to worry about, as there are
            no items located at index 1 yet.</p>
    </CaptionStepComponent>)
}

export function HashMapInsertCab4() {
    return (<CaptionStepComponent title={<h6>
        4. Insert <CodeComponent className="codeKey">KEY</CodeComponent> - <CodeComponent
        className="codeValue">VALUE</CodeComponent> object into the
        sub-collection. <CodeComponent>O(1)</CodeComponent>
    </h6>}>
        <p>Next, we insert our <CodeComponent className="codeKey">KEY</CodeComponent> - <CodeComponent
            className="codeValue">VALUE</CodeComponent> object of <CodeComponent>abc - cab</CodeComponent> into the
            sub-collection we found at index 1.</p>
    </CaptionStepComponent>)
}

export function HashMapInsertCab5() {
    return (<CaptionStepComponent title={<h6>
        5. If necessary, increase HashMap space to maintain an optimal
        balance. <CodeComponent><s>O(n)</s></CodeComponent> <CodeComponent>O(1)</CodeComponent>
    </h6>}>
        <p>Because we only have 2 out of 8 slots, or 25% of our slots filled, we do <i>not</i> need to increase our
            space. We skip this step for now.</p>
    </CaptionStepComponent>)
}
